module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAICAYAAAD0g6+qAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEqADAAQAAAABAAAACAAAAACw+T12AAAAYUlEQVQoFWNkwAPMzMwU//37N+/////xZ8+efYRHKQMjLkmQIX///j0AlJdjZGS8DzTMAZ9hWA1CNgRmESHDMAzCZggxhqEYhM8QQobBDSLGEHyGgQ0ixRBchjGSYwg2wwDOb18JJ8N2mgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/triangle-1.png
// module id = yVOz
// module chunks = 87